import { render, staticRenderFns } from "./shoppingCart.vue?vue&type=template&id=dcab7d7c&scoped=true&"
import script from "./shoppingCart.vue?vue&type=script&lang=ts&"
export * from "./shoppingCart.vue?vue&type=script&lang=ts&"
import style0 from "./shoppingCart.vue?vue&type=style&index=0&id=dcab7d7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcab7d7c",
  null
  
)

export default component.exports